__turbopack_context__.v({
  "deliveryAvailability": "FXcaEG_deliveryAvailability",
  "modalWrapper": "FXcaEG_modalWrapper",
  "paragraph": "FXcaEG_paragraph",
});
